import React from 'react';
import { HumanTeamMember } from '../types';

interface Props {
  member: HumanTeamMember;
  onClick: () => void;
  isSelected?: boolean;
}

const HumanMemberCard: React.FC<Props> = ({ member, onClick, isSelected = false }) => {
  const totalTasks = member.queued_tasks + member.in_progress_tasks + member.completed_tasks + member.failed_tasks;

  return (
    <div
      onClick={onClick}
      style={{
        border: isSelected ? '2px solid #3b82f6' : '1px solid #ddd',
        borderRadius: '8px',
        padding: '16px',
        margin: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        backgroundColor: isSelected ? '#eff6ff' : '#fff',
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'translateY(0)';
        }
      }}
    >
      <h3 style={{ margin: '0 0 8px 0', color: '#333' }}>{member.name}</h3>
      <p style={{ margin: '0 0 8px 0', fontSize: '12px', fontWeight: 'bold', color: '#111' }}>
        Total: {totalTasks} tasks
      </p>
      <div style={{ display: 'flex', gap: '12px', fontSize: '13px' }}>
        <span style={{ color: '#f59e0b' }}>
          ⏳ {member.queued_tasks}
        </span>
        <span style={{ color: '#3b82f6' }}>
          ⚡ {member.in_progress_tasks}
        </span>
        <span style={{ color: '#10b981' }}>
          ✓ {member.completed_tasks}
        </span>
        {member.failed_tasks > 0 && (
          <span style={{ color: '#ef4444' }}>
            ✗ {member.failed_tasks}
          </span>
        )}
      </div>
    </div>
  );
};

export default HumanMemberCard;
